import { principles } from '@/mocks/homeData';
import SectionHead from './SectionHead';

export default function Verification() {
  return (
    <section className="border-y border-background-200 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHead
              index="档案 04"
              kicker="我们怎么核"
              title="证据不是越多越好，是越能对得上越好"
              desc="同一个东西，别处截一张、这里也截一张，不一定就是事实。我们把核验标准摆上台面，让你知道每句话是凭什么说出来的。"
            />
            <a
              href="#ru-kou"
              className="mt-8 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer"
            >
              了解完整核验流程
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-7">
            {principles.map((p, i) => (
              <div
                key={p.title}
                className={`rounded-lg p-5 ${i === 0 ? 'bg-primary-50' : i === 1 ? 'bg-accent-100/60' : 'bg-background-100'}`}
              >
                <div
                  className={`flex h-10 w-10 items-center justify-center rounded-md text-lg ${
                    i === 0 ? 'bg-primary-500 text-background-50' : i === 1 ? 'bg-accent-500 text-foreground-950' : 'bg-secondary-500 text-background-50'
                  }`}
                >
                  <i className={p.icon} aria-hidden="true"></i>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}